module.exports = __webpack_public_path__ + "static/media/micky-mentor.ff5849f6.png";